import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { JhmHttpInterceptorConfig } from "./jhm-http-interceptor-config";
import { UserStore } from "../../stores";

@Injectable()
export class JhmHttpInterceptor implements HttpInterceptor
{
	private apiUrl: string;
	private defaultHeaders: HttpHeaders;
	private formDataHeaders: HttpHeaders;
	private router: Router;
	private userStore = inject(UserStore);

	public constructor(router: Router, config: JhmHttpInterceptorConfig)
	{
		this.router = router;
		this.defaultHeaders = new HttpHeaders({
			"content-type": "application/json",
			"x-portal-type": config.appType
		});

		this.formDataHeaders = new HttpHeaders({
			"x-portal-type": config.appType
		});

		this.apiUrl = config.environment.apiUrl + config.portalPath + "/";
	}

	public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
	{
		let headers: HttpHeaders = req.headers;
		const formData: boolean = (req.body instanceof FormData);
		let headersToUse: HttpHeaders;
		if(formData) // image upload
		{
			headersToUse = this.formDataHeaders;
		}
		else
		{
			headersToUse = this.defaultHeaders;
		}

		headersToUse.keys().forEach((name: string) =>
		{
			const defaultHeader: string[] = this.defaultHeaders.getAll(name);
			if (defaultHeader)
			{
				headers = headers.set(name, defaultHeader);
			}
		});

		const modifiedRequest: HttpRequest<any> = req.clone({
			headers,
			url: this.apiUrl + req.url
		});

		return next.handle(modifiedRequest).pipe(tap(
			(event: HttpEvent<any>) =>
			{
				if (event instanceof HttpResponse)
				{
					// Can log here any data from every request
				}
			},
			(error: any) =>
			{
				if (error instanceof HttpErrorResponse)
				{
					if (401 === error.status)
					{
						this.userStore.clearUser();
						// Remove the old JWT
						localStorage.removeItem("access_token");
						if (Intercom) {
							Intercom("shutdown");
						}
						this.router.navigate(["/login"]);
					}
				}
			}
		));
	}
}
